import {createRouter, createWebHistory} from "vue-router";
import authRoutes from "../components/partners/auth/authRoutes";
import referralRoutes from "../components/partners/referral-portal/auth/referralRoutes";

// Determine which routes to use based on program type
const getProgramType = () => {
    const el = document.querySelector('[data-program-type]');
    return el?.getAttribute('data-program-type') || 'affiliate';
};

const programType = getProgramType();

const routes = programType === 'refer_a_friend' ? referralRoutes : authRoutes;

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    if (window.requires_approval && !['approval', 'complete-invitation'].includes(to.name)) {
        return next({ name: 'approval' });
    }

    // Restrict access to accounts page if sub-accounts feature is disabled or user is a sub-account
    if (to.meta?.restrictSubAccount) {
        if (!window.sub_accounts_enabled || window.is_sub_account) {
            return next({ name: 'dashboard' });
        }
    }

    next();
});

export default router
